import React from 'react';
import { useLocation } from 'react-router-dom';

type AdminSidebarContextValue = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
  isAdminRoute: boolean;
};

const AdminSidebarContext = React.createContext<AdminSidebarContextValue | undefined>(undefined);

export function AdminSidebarProvider({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  const [isOpen, setIsOpen] = React.useState(false);

  React.useEffect(() => {
    // Close sidebar when leaving admin area
    if (!isAdminRoute && isOpen) {
      setIsOpen(false);
    }
  }, [isAdminRoute, isOpen]);

  const value = React.useMemo<AdminSidebarContextValue>(() => ({
    isOpen,
    open: () => setIsOpen(true),
    close: () => setIsOpen(false),
    toggle: () => setIsOpen(prev => !prev),
    isAdminRoute,
  }), [isOpen, isAdminRoute]);

  return (
    <AdminSidebarContext.Provider value={value}>{children}</AdminSidebarContext.Provider>
  );
}

export function useAdminSidebar() {
  const ctx = React.useContext(AdminSidebarContext);
  if (!ctx) {
    throw new Error('useAdminSidebar must be used within AdminSidebarProvider');
  }
  return ctx;
}


